import { Component, OnInit } from '@angular/core';
import { LocationService } from '../../../_services/location.service';
import { ActivatedRoute, Params } from '@angular/router';
import { ContactService } from '../../../_services/contact.service';
@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.scss']
})
export class TermsConditionsComponent implements OnInit {

  country: string;
  language: string;
  page: any;


  constructor(
    private _contactService: ContactService,
    private route: ActivatedRoute,
    private locationService: LocationService
  ) { }
  
  getCustomPages(country: string, language: string) {
    this._contactService.getCustomPages(country, language)
      .subscribe(
        resJSONData => { 
          this.page = resJSONData[0];
          console.log(this.page);

        },
        error => console.log('Error ::' + error)
      )
  }

  ngOnInit(): void {
    this.route.parent.params
      .subscribe(
        (params: Params) => {
          this.country = this.locationService.country;
          this.language = this.locationService.langCode;
          this.getCustomPages(this.country, this.language);
      }
    )
  }
}
